import { ROUTES } from '../const/routes';

export const AVATAR_POR_DEFECTO = 'avatar_101.png';

export const AVATARES_DISPONIBLES = [
  'avatar_101.png',
  'avatar_102.png',
  'avatar_103.png',
  'avatar_104.png',
  'avatar_105.png',
  'avatar_201.png',
  'avatar_202.png',
  'avatar_203.png',
  'avatar_204.png',
  'avatar_205.png',
  'avatar_301.png',
  'avatar_302.png',
  'avatar_303.png',
  'avatar_304.png',
  'avatar_305.png',
  'avatar_306.png',
  'avatar_307.png',
  'avatar_308.png',
  'avatar_309.png',
  'avatar_310.png',
  'avatar_311.png',
  'avatar_312.png',
  'avatar_313.png',
  'avatar_314.png',
  'avatar_315.png',
  'avatar_901.png',
  'avatar_902.png',
  'avatar_903.png',
  'avatar_904.png',
  'avatar_905.png',
];

export const getAvatarSrc = (avatar) =>
  `${ROUTES.rutaAvatares}${avatar || AVATAR_POR_DEFECTO}`;

export const handleAvatarError = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = getAvatarSrc(AVATAR_POR_DEFECTO);
};
